import React from 'react';
import PropTypes from 'prop-types';
import { Svg } from 'react-native-svg';

const Copy = ({ className, color }) => (
    <Svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask
            id="mask0"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            x="4"
            y="6"
            width="4"
            height="15"
        >
            <rect x="4" y="6" width="4" height="15" fill="#C4C4C4" />
        </mask>
        <g mask="url(#mask0)">
            <rect
                x="5"
                y="7"
                width="10.75"
                height="13.0001"
                rx="2"
                stroke={color}
                strokeWidth="2"
            />
        </g>
        <mask
            id="mask1"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            x="8"
            y="17"
            width="9"
            height="4"
        >
            <rect x="8" y="17" width="9" height="4" fill="#C4C4C4" />
        </mask>
        <g mask="url(#mask1)">
            <rect x="5" y="5" width="11" height="14.9996" rx="2" stroke={color} strokeWidth="2" />
        </g>
        <rect x="9" y="3" width="11" height="13" rx="2" stroke={color} strokeWidth="2" />
    </Svg>
);

Copy.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
};

Copy.defaultProps = {
    className: '',
    color: '#333333',
};

export default Copy;
